<!-- 配信履歴表示用コンポーネント -->
<template>
    <div>
        <div class="text-center">
            <div v-show="isGetSearchParm" class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div v-show="!isGetSearchParm" class="p-0 container s-alert-container">
            <div class="container-fluid web-header">
                <div>
                    <nav class="navbar navbar-dark">
                        <h1 class="mb-0 web-header-text">多気町防災行政無線情報</h1>
                    </nav>
                </div>
            </div>
            <div class="header__logo-box">
                <img src="../img/logo.png" class="header__logo my-3" alt="多気町">
            </div>
            <div class="container-fluid mb-2 web-shadow s-alert-page-label">
                <div class="container d-flex justify-content-center">
                    <span class="text-center navbar navbar-dark navbar-brand mb-0 p-2">放送内容一覧</span>
                </div>
            </div>
            
            
            <div v-show="!isGetSearchParm">
                <div class="">
                    <div v-show="!(allDisplayDataVal==0) && !isGetSendHist" class="row  ">
                        <div class="col-md-8 web-font-main normalDelivery-left">
                            表示：{{fromDisplayDataVal}}～{{toDisplayDataVal}}件
                        </div>
                        <div class="col-md-4 web-font-main normalDelivery-right">
                            総数：{{allDisplayDataVal}}件
                        </div>
                    </div>
                    <div v-show="allDisplayDataVal==0 && !isGetSendHist" class="row  ">
                        <div class="col-md-8 web-font-main normalDelivery-left">
                            表示：{{allDisplayDataVal}}件
                        </div>
                        <div class="col-md-4 web-font-main normalDelivery-right">
                            総数：{{allDisplayDataVal}}件
                        </div>
                    </div>
                    <div v-show="isGetSendHist" class="row">
                        <div class="col-md-8 web-font-main normalDelivery-left">
                            表示：0件
                        </div>
                        <div class="col-md-4 web-font-main normalDelivery-right">
                            総数：0件
                        </div>
                    </div>
                    <div>
                        <div>
                            <table class="table-sm sendhist-table web-font-main">
                                <thead class="sendhist-thead">
                                    <tr >
                                        <th class="s-alert-column-datetime none-scroll tabele-header-border">配信日時</th>
                                        <th class="s-alert-column-groups none-scroll tabele-header-border">地区</th>
                                        <th class="s-alert-column-contents none-scroll tabele-header-border">詳細内容</th>
                                        <th class="s-alert-column-sound none-scroll tabele-header-border">音声再生</th>
                                    </tr>
                                </thead>

                                <tbody v-show="!isGetSendHist">
                                    <tr v-for="(sendHist, index) in displaysendHists" :key="index">
                                        <td class="align-top">{{ sendHist.addDtm }}</td>
                                        <td class="align-top">{{ sendHist.grpNm }}</td>
                                        <td>
                                            <span class="fw-bold">{{ sendHist.textTitle }}</span><br/>
                                            <br/>
                                            <span v-html="autoLink(sendHist.dispText)"></span>
                                        </td>
                                        <!-- <td>{{ sendHist.sendType }}{{ sendHist.sendNo }} -->
                                        <td class="text-center none-header" v-show="sendHist.playBackType=='再生'">
                                            <button class="play-btn" @click="playMp3(sendHist.sendNo,index)">
                                                <img src="../img/btn_play.png" class=" s-alert-audio-toggle">
                                            </button>
                                        </td>
                                        <td class="text-center none-header" v-show="sendHist.playBackType=='停止'">
                                            <button class="play-btn" @click="checkReadAloudOrPlayMp3(lastPlayIndex)">
                                                <img src="../img/btn_stop.png" class=" s-alert-audio-toggle">
                                            </button>
                                        </td>
                                        <td class="text-center none-header" v-show="sendHist.playBackType=='読上'">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-center mt-2">
                                <div v-show="isGetSendHist" class="spinner-border" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <div class="none-search-result mt-2">
                                <div v-show="allDisplayDataVal==0 && !isGetSendHist">
                                    最新の放送はありません。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sendhist_footer" v-show="!isGetSendHist && allDisplayDataVal!=0">
                        <div class="clearfix">
                            <input type="button" value="前のページへ"  :disable="isPage" v-show="!isBackPage" @click="backPage()" class="sendhist-operationButtons btn prev-page float-left"/>
                            <input type="button" value="次のページへ" :disable="isPage" v-show="!isNextPage"  @click="nextPage()" class="sendhist-operationButtons btn prev-page float-right"/>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import ApiPath from "../contents/ApiPath.vue";
    import UserHelper from "../contents/userHelper.vue";
    export default {
        data: function () {
            return {
                //処理待ちフラグ
                isGetSearchParm:false,
                isGetSendHist:false,
                isClearSearchParm:false,
                isReadAloudOrPlayMp3:false,
                //ページネーション表示フラグ
                isBackPage:false,
                isNextPage:false,


                //検索条件初期値
                searchParmModes:[],
                searchParmUsers:[],
                searchParmGrps:[],
                searchParmSendTypes:[],
                searchParmFromDate:null,
                searchParmToDate:null,

                //検索条件
                searchParm:{fromAddDtm:"",toAddDtm:"",ModeCd:null,UserCd:"",GrpCd:"",TypeCd:null},
                defaultSearchParm:{fromAddDtm:"",toAddDtm:"",ModeCd:null,UserCd:"",GrpCd:"",TypeCd:null},

                //検索結果
                sendHists:[],
                //表示用検索結果
                displaysendHists:[],

                //表示件数
                fromDisplayDataVal:null,
                //表示件数
                toDisplayDataVal:null,
                //総数
                allDisplayDataVal:0,
                //１ページあたりのデータ数
                pagenationVal:10,

                //音声再生用の共通変数
                audioObject:new Audio(),
                speechSynth : window.speechSynthesis,
                lastPlayIndex:null,

            }
        },
        methods: {
            /**
             * 初期表示時の処理
             */
            init: async function(){
                //console.log("befor.init");
                //axiosのヘッダー設定
                await this.setHeader();

                this.getSendHist();
                //console.log("after.init");
            },

            /**
             * axiosにrequest headerを追加
             */
            setHeader: async function(){
                //axiosにヘッダー情報追加
                axios.defaults.headers.common['Content-Type'] = 'application/json';
                axios.defaults.headers.common['ZUMO-API-VERSION'] = '2.0.0';

                //console.log("axios.defaults.headers:",axios.defaults.headers.common);
            },
            /**
             * 検索処理
             */
            getSendHist : function(){
                //console.log("befor.getSendHist");

                this.$data.isGetSendHist = true;

                // //検索前に音声停止
                // this.checkReadAloudOrPlayMp3(this.$data.lastPlayIndex);

                // //this.$data.searchParmをセッションに上げておく（返信状況確認画面から戻った時に詰めなおす）
                // sessionStorage.setItem('sendHistSearchParm', JSON.stringify(this.$data.searchParm));

                axios.get(ApiPath.getSendHist)
                .then(response => {
                    this.$data.isGetSendHist = false;
                    //console.log("after.getSendHist");
                    this.$data.sendHists =response.data;                  
                    //console.log("SendHist:",this.$data.sendHists);
                    //console.log("response.data:",response.data);
                    this.allDisplayDataVal = this.$data.sendHists.length;

                    //console.log("sendHists:",this.$data.sendHists);
                    this.resetPagination();
                    this.createDisprayData();
                    //this.checkParm();

                }).catch(error => {
                    this.$data.isGetSendHist = false;
                    //this.checkParm();
                    //console.log("error.getSendHist");
                    //共通のエラー処理
                    UserHelper.methods.authorityError(error,this.$router,this.$route);
                });
            },
            /**
             * テキスト内にリンクがある場合、aタグに変換する
             */
            autoLink(text) {
                return this.isString(text) ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'>$1</a>").replace(/\n/g, '<br />') : '';
            },
            isString(obj) {
                return (typeof (obj) === "string" || obj instanceof String);
            },

            /**
             * 音声再生処理
             */
            playMp3($SendNo,$index) {
                const difference = 1;
                var targetSendHistIndex = $index + this.$data.fromDisplayDataVal - difference;
                //console.log('targetSendHistIndex:',targetSendHistIndex);

                //APIURL作成
                var path = ApiPath.playMp3 + $SendNo;

                //console.log('start:',path);

                //テーブル上の再生ボタンを停止に変更
                this.$data.sendHists[targetSendHistIndex].playBackType = '停止';

                //
                this.checkReadAloudOrPlayMp3(this.$data.lastPlayIndex);

                this.$data.lastPlayIndex = targetSendHistIndex;
                this.$data.isReadAloudOrPlayMp3=true;

                axios.get(path,)
                .then(response => {
                    //console.log("playMp3.OK");
                    //音源をbase64形式（テーブルに保存されている情報のまま）で受け取り、
                    //それをバイト配列に変換しURL化したものをAudioのsrcに入れている
                    //取得API直叩きは、リクエストヘッダーを付加できなかったため、採用していない
                    //safariでは動作しないためblob形式には変換せずにbase64形式のまま再生する
                    // var decoded = this._base64ToArrayBuffer(response.data);

                    // var binaryData = [];
                    // binaryData.push(decoded);
                    // var blob = new Blob([decoded], {type: 'audio/mp3'})

                    // //content-length で decoded のlengthを取得する⇒ヘッダーにつける
                    // const url = window.URL.createObjectURL(blob);

                    this.$data.audioObject = new Audio();
                    const datauri = "data:audio/mp3;base64," + response.data;

                    this.$data.audioObject.src = datauri;

                    //console.log("playMp3:",datauri);

                    //再生処理
                    //再生できる音源を取得したのを確認後、再生
                    this.$data.audioObject.addEventListener("canplaythrough", () => {
                        /* the audio is now playable; play it if permissions allow */
                        //console.log("playMp3.play:",this.$data.audioObject.currentTime);
                        
                        this.$data.audioObject.play();
                        window.URL.revokeObjectURL(datauri);
                    });
                    //再生終了後の処理
                    this.$data.audioObject.addEventListener("ended", () => {
                        /* the audio is now playable; play it if permissions allow */
                        //console.log("playMp3.ended");
                        this.$data.sendHists[targetSendHistIndex].playBackType = '再生';
                        this.$data.isReadAloudOrPlayMp3=false;
                    });

                    this.$data.audioObject.load();

                }).catch(error => {
                    this.$data.isReadAloudOrPlayMp3 = false;
                    //this.checkParm();
                    //console.log(error);
                    //共通のエラー処理
                    UserHelper.methods.authorityError(error,this.$router,this.$route);
                });
            },

            /**
             * 音声再生前に現在の再生状態をチェック
             * すでに再生中の音声がであれば、停止する
             * $index：最後に再生した音声のテーブルレコード番号
             */
            checkReadAloudOrPlayMp3($index){

                if(this.$data.isReadAloudOrPlayMp3){
                    //console.log('checkReadAloudOrPlayMp3:stopMp3');
                    this.$data.audioObject.pause();
                    this.$data.audioObject.currentTime = 0;
                    //停止時に、sendHistsの中の停止したレコードのsendtypeを書き換える（停止⇒再生）
                    if($index!=null){
                        this.$data.sendHists[$index].playBackType = '再生';
                        this.$data.isReadAloudOrPlayMp3 = false;
                        this.$data.audioObject = new Audio();

                    }
                }
                if(this.$data.speechSynth.speaking){
                    //console.log('checkReadAloudOrPlayMp3:ReadAloud');
                    this.$data.speechSynth.cancel();
                    //停止時に、sendHistsの中の停止したレコードのsendtypeを書き換える（停止⇒読上）
                    if($index!=null){
                        this.$data.sendHists[$index].playBackType = '読上';
                        this.$data.speechSynth = window.speechSynthesis;
                    }
                }
            },

            /**
             * base64を配列に変換
             */
            _base64ToArrayBuffer(base64) {
                var binary_string = window.atob(base64);
                var len = binary_string.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes;
            },

            /**
             * 画面表示用データ作成（ページネーション用）
             */
            createDisprayData(){
                //console.log("createDisprayData");
                this.$data.displaysendHists= this.$data.sendHists.slice(this.$data.fromDisplayDataVal -1, this.$data.toDisplayDataVal)
            },

            /**
             *表示件数作成＋0件時のフラグ設定
             */
            createSearchResultsParm(){
                //console.log("createSearchResultsParm");
                this.$data.fromDisplayDataVal = (this.$data.nowPage - 1) *this.$data.pagenationVal + 1
                this.$data.toDisplayDataVal = (this.$data.nowPage * this.$data.pagenationVal) >= this.$data.allDisplayDataVal ? this.$data.allDisplayDataVal : this.$data.nowPage * this.$data.pagenationVal;
                if(this.$data.allDisplayDataVal == 0){
                    this.$data.isNothingResult = true;
                }else{
                    this.$data.isNothingResult = false;
                }
            },

            /**
             * 検索時にページネーションの設定をreset
             */
            resetPagination(){
                //console.log("resetPagination");
                this.$data.nowPage = 1;
                this.createSearchResultsParm();
                this.showPagenation();
            },

            /**
             * 次へbuttonを押したときの処理
             */
            nextPage(){
                //console.log("nextPage");
                this.$data.isPage = true;
                this.$data.nowPage = this.$data.nowPage + 1;
                this.createSearchResultsParm();
                this.createDisprayData();
                this.showPagenation();
                this.$data.isPage = false;
                //this.checkParm();
            },

            /**
             * 前へbuttonを押したときの処理
             */
            backPage(){
                //console.log("backPage");
                this.$data.isPage = true;
                this.$data.nowPage = this.$data.nowPage - 1;
                this.createSearchResultsParm();
                this.createDisprayData();
                this.showPagenation();
                this.$data.isPage = false;
                //this.checkParm();
            },

            /**
             * ページネーション表示用のフラグ設定処理
             * 1ページ目なら前へbuttonは非表示
             * 最終ページなら次へbuttonは非表示
             */
            showPagenation(){
                //console.log("showPagenation");
                this.$data.isBackPage = this.$data.nowPage == 1 ? true:false;
                this.$data.isNextPage = (this.$data.nowPage * this.$data.pagenationVal) >= this.$data.allDisplayDataVal ? true:false;
            }
        },
        mounted() {
            this.init();
            //音声再生中にリロードまたは画面を閉じられた場合に、再生停止する処理
            window.addEventListener('beforeunload', () => {
                this.checkReadAloudOrPlayMp3(this.$data.lastPlayIndex);
            })
        },
    }
</script>

<style lang="scss">

:root{
    --bs-font-sans-serif: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    --bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
    --main-color: #4E6D1D;
    --main-font-color: #fff;
    --second-color: #4E6D1D;
    --second-font-color: #fff; 
    --table-header-color: #E0F2D8;
    --table-header-font-color: #000;
    --table-frame-color: #000;
    --table-content-odd-color: #fff;
    --table-content-even-color: #fff;
    --body-backgroud-color: #F9F6EE;
    --none-display-font-color: #4E75AE;
    --main-font-family: "MS Mincho","MS 明朝","Mincho",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    --second-font-family: "MS Mincho","MS 明朝","Mincho",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
}

.sendhist-operationButtons {
    --bs-btn-color: #007bff !important;
    --bs-btnborder-color: #000;
    --bs-btn-bg: #fff; 
    --bs-btn-border-color: #dee2e6 !important;
    --bs-btn-hover-color: #0056b3;
    --bs-btn-hover-bg: #e9ecef !important;
    --bs-btn-hover-border-color: #dee2e6 !important;
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: #0056b3;
    --bs-btn-active-bg: #e9ecef;
    --bs-btn-active-border-color: #dee2e6 !important;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #0d6efd;
    --bs-btn-disabled-border-color: #0d6efd;
    width: 122px;
}

// ボディー部
.body-backgroud{
    background-color: var(--body-backgroud-color);
}

// ヘッダー部
.web-header{
    background-color: var(--main-color);
}

.web-header-text{
    color: var(--main-font-color);
    font-family: var(--main-font-family);
    font-size: 1.25rem;
    font-weight: 700!important;
}

// 中央部
.s-alert-page-label{
    line-height: 1.2;
    background-color: var(--second-color);
    color: var(--second-font-color);
    font-family: var(--second-font-family);
}

// テーブル部
.sendhist-table {
    width: 100%;
}

.sendhist-thead {
    border-left: none;
    border-top: none;
    text-align:center
}

.sendhist-table tr:nth-child(odd) {
  // background-color:rgba(0,0,0,.05);
  background-color: var(--table-content-odd-color);
}

.sendhist-table tr:nth-child(even) {
  background-color: var(--table-content-even-color);
}

.sendhist-table tr td {
  border: 2px solid var(--table-frame-color);
}

table.sendhist-table th {
    background-color: var(--table-header-color);
    color: var(--table-header-font-color);
}

.tabele-header-border{
    border: 2px solid var(--table-frame-color);
}

.sendhist-operationButtons:focus {
    box-shadow: 0 0 0 0.25rem #c6e7ff;
}

.header__logo {
  height: 61.67px;
  //padding: 15px;
}

.navbar-brand {
    margin-left: var(--bs-navbar-brand-margin-end);
}

.none-search-result{
    color: var(--none-display-font-color);
}

.normalDelivery-left {
    color: black;
    // margin-top: 20px;
    text-align: left;
}

.normalDelivery-right {
    color: black;
    // margin-top: 20px;
    text-align: right;
}

.s-alert-container {
    min-width: 1024px;
    max-width: 1024px !important;
}

.float-left {
    float: left!important;
}

.float-right {
    float: right!important;
}

.page-btn {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
}

.page-btn:hover {
    z-index: 2;
    color: #0056b3;
    text-decoration: none;
    background-color: #e9ecef;
    border-color: #dee2e6;
}

.s-alert-column-datetime {
    width: 135px;
}
.s-alert-column-groups {
    width: 300px;
}
.s-alert-column-contents {
    width: 487px;
}
.s-alert-column-sound {
    width: 100px;
}

.s-alert-content-contents{
    white-space: pre-line;
}

.s-alert-audio-toggle {
    width: 100%;
    max-width: 48px;
    height: auto;
    cursor: pointer;
}

.sendhist_footer {
    margin-bottom: 0.5rem;
}

.play-btn{
    border: none;
    background: none;
}

</style>
